<hb-modal-dialog
  heading="{{'MaintenanceStrategyPlannedMaintenanceDialog.PlannedMaintenance' | i18next}}"
  [okDisabled]="selectedPlannedMaintenance.length === 0"
  (okClicked)="submitClick()">
  <div content>
    <div class="available-planned-maintenance-table-wrapper">
      <hb-maintenance-strategy-available-planned-maintenance-table
        [plannedMaintenance]="availablePlannedMaintenance"
        [canSelect]="true"
        (selectionChanged)="onSelectionChanged($event)"
      ></hb-maintenance-strategy-available-planned-maintenance-table>
    </div>
  </div>
</hb-modal-dialog>